import React from 'react';
import { faqs } from '../../data/faqs';

const FAQSection = () => (
  <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-16">
        <span className="inline-block mb-3 text-pink-600 font-medium">HAVE QUESTIONS?</span>
        <h2 className="text-3xl sm:text-4xl font-bold font-serif text-center text-gray-900 mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Find answers to common questions about our cakes and ordering process
        </p>
      </div>
      <div className="space-y-8">
        {faqs.map((faq) => (
          <div key={faq.question} className="border-b border-gray-200 pb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-3 flex items-center">
              <svg className="w-5 h-5 text-pink-500 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              {faq.question}
            </h3>
            <p className="text-gray-600 pl-8">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FAQSection;
